/**
 * Referral attribution — capture a ?ref=CODE that arrives via a QR scan or a
 * shared link and stash it so it survives until the visitor signs up.
 */
const REF_KEY = 'aloha_ref_code';

/** Read ?ref= from the current URL and persist it (first-touch wins). */
export const captureRefFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get('ref') || '').trim().toUpperCase().slice(0, 16);
    // Keep the first referral code we ever see for this browser.
    if (code && !localStorage.getItem(REF_KEY)) {
      localStorage.setItem(REF_KEY, code);
    }
    return localStorage.getItem(REF_KEY) || null;
  } catch {
    return null;
  }
};

/** The stored referral code, if any. */
export const getStoredRef = () => {
  try { return localStorage.getItem(REF_KEY) || null; } catch { return null; }
};

/** Clear it once it's been consumed at signup. */
export const clearStoredRef = () => {
  try { localStorage.removeItem(REF_KEY); } catch { /* ignore */ }
};

/** Build a shareable referral URL for a code (absolute, current origin). */
export const referralUrl = (code) => {
  const origin = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
  return `${origin}/register?ref=${encodeURIComponent(code || '')}`;
};
